import { render, staticRenderFns } from "./uhrny-zrazok.vue?vue&type=template&id=16d2666e&"
import script from "./uhrny-zrazok.vue?vue&type=script&lang=js&"
export * from "./uhrny-zrazok.vue?vue&type=script&lang=js&"
import style0 from "./uhrny-zrazok.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports